var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMasonry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-wall-3196680 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1299 13.272H18.4811V16.4312H10.1299V13.272Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1299 5.00006H18.4811V8.35286H10.1299V5.00006Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M5.51758 9.23315H13.8655V12.3917H5.51758V9.23315Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M5.51758 17.3105H13.8655V20.6681H5.51758V17.3105Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M1 13.2721H9.25088V16.4306H1V13.2721Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M1 9.23276H4.6388V12.392H1V9.23276Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M14.7461 9.23276H23.0005V12.392H14.7461V9.23276Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.3594 13.2721H23.0004V16.4306H19.3594V13.2721Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M1.44 20.6684H4.6388V17.3112H1V20.2284C1 20.4704 1.19362 20.6684 1.44 20.6684V20.6684Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M14.7461 20.6684H22.5605C22.8025 20.6684 23.0005 20.4704 23.0005 20.2284V17.3112H14.7461V20.6684Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M22.5601 4.99994H19.3613V8.35274L23.0001 8.35283V5.44003C23.0001 5.19356 22.8021 4.99994 22.5601 4.99994V4.99994Z",
    fill: "#656565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M9.25 5.00006H1.44C1.198 5.00006 1 5.19368 1 5.44006V8.35286H9.25V5.00006Z",
    fill: "#656565"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasonry);
export default __webpack_public_path__ + "static/media/masonry.a37884ce569f7426e4de2d076b2d3575.svg";
export { ForwardRef as ReactComponent };